import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import '../html-template/showcards.scss';
import { range, shuffle } from 'lodash';

class ShowCards extends Component {

    constructor(props){
        super(props);
			this.questions = [
					{
						name: "Q32",
						folder: "q32",
						num_of_cards: 6,
						cards: shuffle(range(1, 7)),
						per_page: 1
					},
					{
						name: "Q33",
						folder: "q33",
						num_of_cards: 39,
						cards: shuffle(range(1, 40)),
						per_page: 1
					},
					{
						name: "Q34",
						folder: "q34",
						num_of_cards: 6,
						cards: shuffle(range(1, 7)),
						per_page: 1
					},
					{
						name: "Q36b",
						folder: "q36b",
						num_of_cards: 5,
						cards: range(1, 6),
						per_page: 1
					}
				];

			const {params} = this.props.match;
			const question_folder = params['id'];

			let showCard = undefined;
			if(question_folder){
				const showCardList = this.questions.filter(q => q.folder.toLowerCase() == question_folder.toLowerCase());

				if(showCardList.length > 0){
					showCard = showCardList[0];
				}
			}

			this.state = {
				current_pos: 0,
				showCard: showCard
			};
		}

	keyFunction = (e) => {
		switch(e.key){
			case 'ArrowLeft':
				this.prevCard();
				break;
			case 'ArrowRight':
				this.nextCard();
				break;
		}
	}
	componentDidMount(){
    document.addEventListener("keyup", this.keyFunction, false);
	}
	componentWillUnmount(){
    document.removeEventListener("keyup", this.keyFunction, false);
  }
	nextCard = () => {
		this.setState((prevState) => {
			const {current_pos, showCard} = prevState;
			return {
				current_pos: current_pos < (showCard.num_of_cards - 1) ? current_pos + 1 : current_pos
			}
		});
	}

	prevCard = () => {
		this.setState((prevState) => {
			const {current_pos, showCard} = prevState;
			return {
				current_pos: current_pos == 0 ? current_pos : current_pos - 1
			}
		});
	}
    render(){
			const {showCard, current_pos} = this.state;
			return(
				<div className="showcards">
					<div className="question-nav">
						<div className="q-list">
						{
							this.questions.map((q, i) => {
								return <a key={i} className={
									"q-btn" +
										(showCard && q.folder == showCard.folder ? " active" : "")
									} href={"/show-cards/"+q.folder}>{q.name}</a>
							})
						}
						</div>
						<Link to="/" className="q-btn home">Trang chủ</Link>
					</div>
					{
						!showCard ?
							<div className="showcard-list">
							<h2>Vui lòng chọn showcard</h2>
							</div>
							: <div className="showcard-list">
								<div className="prev-btn nav-btn">
									<button className={
										"btn" + 
										(current_pos == 0 ? " disabled" : "")
										} onClick={this.prevCard}>&#60; Lùi</button>
								</div>
								{showCard.cards.map((c,i) =>
								<div key={c} className="showcard-item"
									style={{display: current_pos == i ? 'flex': 'none'}}
								>
									<img src={process.env.PUBLIC_URL + '/assets/showcards/'+showCard.folder+'/'+c+'.jpg'} 
										className="showcard-img"
									/>
								</div>
								)
								}


								<div className="next-btn nav-btn">
									<button className={
										"btn" + 
											((current_pos == showCard.num_of_cards - 1) ? " disabled" : "")
										} onClick={this.nextCard}>Tiếp &#62;</button>
								</div>
							</div>
					}
				</div>
			);
		}
}

export default ShowCards;
